// src/redux/deleteMessageSlice.js
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import Swal from 'sweetalert2';

export const deleteMessage = createAsyncThunk(
  'message/delete',
  async (id, { rejectWithValue }) => {
    const token = localStorage.getItem('token');
    const role = localStorage.getItem('role');

    if (role !== 'superadmin') {
      Swal.fire({
        icon: 'error',
        title: 'Access Denied',
        text: 'Only Superadmin can delete messages',
      });
      return rejectWithValue('Unauthorized');
    }

    try {
      const response = await fetch(`https://api.thevisaman.in/api/contacts/delete/${id}`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to delete message');
      }

      Swal.fire({
        icon: 'success',
        title: 'Deleted',
        text: data.message || 'Message deleted successfully',
      });

      return data;
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Delete Failed',
        text: error.message,
      });
      return rejectWithValue(error.message);
    }
  }
);

const deleteMessageSlice = createSlice({
  name: 'messageDelete',
  initialState: {
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deleteMessage.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(deleteMessage.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(deleteMessage.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export default deleteMessageSlice.reducer;
